__turbopack_context__.v({
  "className": "_5x4cVW_className",
  "variable": "_5x4cVW_variable",
});
